import { newsActions } from "./news.action.types";
import { api } from "../../lib/api";

export const getArticles = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: newsActions.GET_ARTICLES_PENDING,
      });
      let res = await api.getCMSContent('/tables/news/rows/');

      dispatch({
        type: newsActions.GET_ARTICLES_SUCCESS,
        articles: res.data,
      })
    } catch (error) {
      dispatch({
        type: newsActions.GET_ARTICLES_ERROR,
        error: error,
      })
    }
  }
};
